import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  ApiBlueprint,
  configApiRef,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';

const scmIntegrationsApi = ApiBlueprint.make({
  name: 'scm-integrations',
  params: defineParams =>
    defineParams({
      api: scmIntegrationsApiRef,
      deps: { configApi: configApiRef },
      factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
    }),
});

const scmAuthApi = ApiBlueprint.make({
  name: 'scm-auth',
  params: defineParams => {
    const factory = ScmAuth.createDefaultApiFactory();
    return defineParams({
      api: factory.api,
      deps: factory.deps,
      factory: factory.factory,
    });
  },
});

export const apisModule = createFrontendModule({
  pluginId: 'app',
  extensions: [scmIntegrationsApi, scmAuthApi],
});
